import { Navigate } from "react-router-dom";

/** Admin Users component. */
export default function AdminUsers() {
  return <Navigate to="/admin/settings?tab=users" replace />;
}
